import React from "react";
import { Navigate } from "react-router-dom";
import OnePage from "../pages/Landing/OnePage";
import AboutUs from "../pages/Landing/AboutUs";
import ContactUs from "../pages/Landing/ContactUs";
import Product from "../pages/Landing/Products";
import SnacksMachine from "../pages/Landing/OnePage/Services/SnacksMachine";
import NescafeMachine from "../pages/Landing/OnePage/Services/NescafeMachine";
import PlantOnRent from "../pages/Landing/OnePage/Services/PlantOnRent";
import Stationary from "../pages/Landing/OnePage/Services/Stationary";
import Gifting from "../pages/Landing/OnePage/Services/CorporateGifting";
import TataMachine from "../pages/Landing/OnePage/Services/TataMachine";
import SanitoryMachine from "../pages/Landing/OnePage/Services/SanitoryMachine";
import TissuePaper from "../pages/Landing/OnePage/Services/TissuePaper";
import CleaningChemicals from "../pages/Landing/OnePage/Services/CleaningChemicals";
import Housekeeping from "../pages/Landing/OnePage/Services/Housekeeping";
import Boat from "../pages/Landing/OnePage/Services/Boat";
import Snacks from "../pages/Landing/OnePage/Services/ReadyToEat";
import Juicer from "../pages/Landing/OnePage/Services/Juicer";
import Policies from "../pages/Pages/Policies";
import Conditions from "../pages/Pages/Conditions"
const publicRoutes = [
  { path: "/", component: <OnePage /> },
  {path: "/about", component: <AboutUs/>},
  {path: "/contact", component: <ContactUs/>},
  {path: "/products", component: <Product/>},
  {path: "/policies", component: <Policies/>},
  {path: "/conditions", component: <Conditions/>},
  {path: "/services/tatamachine", component: <TataMachine/>},
  {path: "/services/snacksmachine", component: <SnacksMachine/>},
  {path: "/services/nescafemachine", component: <NescafeMachine/>},
  {path: "/services/sanitorymachine", component: <SanitoryMachine/>},
  {path: "/services/tissuepapers", component: <TissuePaper/>},
  {path: "/services/cleaningchemicals", component: <CleaningChemicals/>},
  {path: "/services/housekeeping", component: <Housekeeping/>},
  {path: "/services/stationary", component: <Stationary/>},
  {path: "/services/plantOnRent", component: <PlantOnRent/>},
  {path: "/services/gifting", component: <Gifting/>},
  {path: "/services/boat", component: <Boat/>},
  {path: "/services/snacks", component: <Snacks/>},
  {path: "/services/juicer", component: <Juicer/>},
  {
    path: "/",
    exact: true,
    component: <Navigate to="/landing" />,
  },
  { path: "*", component: <Navigate to="/" /> },

];

export { publicRoutes };